export default __webpack_public_path__ + "static/media/medal.dbeab5bc.svg";